import request from "@/utils/request";

export const getUser = () => request.get("/permissions/users");

export const getRoles = () => request.get("/permissions/roles");

export const deleteRoles = (id) =>
  request.post(`/permissions/users/${id}/delete-roles
  `);

export const updateUser = ({ id, field } = {}) =>
  request.post(`/permissions/users/${id}/assign-roles`, field);

export const getUserRoles = (id) =>
  request.get(`/permissions/users/${id}/roles
`);
